<!-- Accessibility: Skip to main content link for keyboard users -->
<a href="#main-content" class="skip-to-main">Skip to main content</a>

<!-- Application Layout -->
@if (showHeader) {
  <app-header />
}

<!-- Main Content -->
<main id="main-content" class="main-content" tabindex="-1">
  <router-outlet />
</main>

<!-- Guided Tour Overlay -->
<app-tour-overlay />
